<template>
  <!-- <div style="min-width: 1000px;margin-left: 50px;"> -->
  <div class="outBox">
		
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :key="$route.fullPath"
      >
        <!-- 这里是会被缓存的视图组件 -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件 -->
    </router-view>
  </div>
</template>

<script>
import ResizeMixin from "./mixin/ResizeHandler";

export default {
  name: "Layout",
  data() {
    return {
      menu: this.$store.state.user.resouces,
      logo: { icon: "su-icon-logo", title: "智慧校园" },
      host: window.location.protocol + "//" + window.location.host,
    };
  },
  components: {},
  mixins: [ResizeMixin],
  mounted() {},
	// watch:{
	// 	systemSetting: {
	// 		handler: 'updateSystemSetting'
	// 	},
	// },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  methods: {
    routerHandle(item) {
      if (item.server.includes(this.host)) {
        this.$router.push({ path: item.path });
      } else {
        let path = item.path.replace("/", "");
        var route = item.server + path;
        window.location.href = route;
      }
    },
    checkSelfRoute() {},
		// updateSystemSetting(){
		// 	let favIcon = this.systemSetting.favIcon;
		// 	// let title = this.systemSetting.title;
		// 	// if (title) {
		// 	// 	document.title = title;
		// 	// }
		// 	if (favIcon) {
		// 		let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		// 		link.type = 'image/x-icon';
		// 		link.rel = 'shortcut icon';
		// 		link.href = favIcon;
		// 		document.getElementsByTagName('head')[0].appendChild(link);
		// 	}
		// },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.outBox{
  width: 100%;
  height: 100%;
  // margin-left: 50px;
  //  min-width: 1000px;
}
.app-main {
  /*50 = navbar  */
  min-height: 0;
  position: relative;
  overflow: hidden;
}
.main-container {
  margin-left: 50px !important;
  width: calc(100% - 50px);
}
.appFooter {
  font-size: 12px;
  color: #bec9d2;
  line-height: 20px;
  text-align: center;
}
.iframe {
  height: calc(100vh - 50px);
  width: 100%;
}
</style>
